/* unplugin-vue-components disabled */import script from "./XFlexCtx.vue?vue&type=script&setup=true&lang=ts"
export * from "./XFlexCtx.vue?vue&type=script&setup=true&lang=ts"

import "./XFlexCtx.vue?vue&type=style&index=0&id=60e6757e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e6757e"]])

export default __exports__